
import LogoCloud from '~/components/global/LogoCloud'
import Faq from '~/components/global/Faq'
import Callout from '~/components/global/Callout'
import CtaHero from '~/components/global/CtaHero'

export default {
  name: 'ConvertPage',
  components: { CtaHero, Callout, Faq, LogoCloud },
  props: {
    convert: {},
  },
}
